import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { CircleCheck } from "lucide-react";

import messages from "../../../assets/locale/messages";
import { UIActionModal, UIButton } from "../../ui";
import {
  REQUEST_TYPES,
  fillTemplate,
  formatAmount,
} from "../publishingRequestsUtils";

import "../PublishingRequests.scss";

/** Success popup after a request is accepted, carrying the recorded amount. */
const RequestAcceptedModal = ({ request, onClose }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { publishingRequests: t } = messages[lang];
  const copy = request ? t[request.type] : null;
  const message =
    request?.type === REQUEST_TYPES.crewSizeChange
      ? fillTemplate(copy.acceptedMessage, {
          size: request.crewSize?.name ?? "",
        })
      : copy?.acceptedMessage;

  return (
    <UIActionModal
      open={Boolean(request)}
      variant="info"
      maxWidth="xs"
      showIcon={false}
      onClose={onClose}
      actions={
        <UIButton
          className="publishing-request-accepted__done"
          appearance="gradient"
          onClick={onClose}
        >
          {t.done}
        </UIButton>
      }
    >
      <span className="ui-action-modal__icon ui-action-modal--info">
        <CircleCheck size={32} aria-hidden />
      </span>
      <Typography component="h2" className="ui-action-modal__title">
        {copy?.acceptedTitle}
      </Typography>
      <Typography component="p" className="text-body-sm publishing-request-accepted__message">
        {message}
      </Typography>
      <Typography component="p" className="text-heading-xl publishing-request-accepted__amount">
        {request
          ? fillTemplate(t.amountValue, { amount: formatAmount(request.amount) })
          : ""}
      </Typography>
    </UIActionModal>
  );
};

RequestAcceptedModal.propTypes = {
  /** The accepted request; null keeps the popup closed. */
  request: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

RequestAcceptedModal.defaultProps = {
  request: null,
};

export default RequestAcceptedModal;
